import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "summary-view" }
const _hoisted_2 = { class: "d-flex justify-space-between pa-6" }
const _hoisted_3 = { class: "d-flex mx-6" }
const _hoisted_4 = {
  key: 0,
  class: "pa-4 bg-blue-lighten-1 d-flex justify-center"
}
const _hoisted_5 = {
  key: 1,
  class: "pa-4 bg-blue-lighten-1 d-flex justify-center"
}

import RankList from "@/components/proposal/RankList.vue";
import TileRank from "@/components/board/TileRank.vue";
import { ref, watch } from "vue";
import { ApiMap } from "@/api/type";
import { useApi } from "@/api/handler";
import { log } from "@/api";
import ChatBox from "@/components/ChatBox.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryBox',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props
const showOverlay = ref<boolean>(false)
const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const studentLog = ref<ApiMap['/log/student/list']['resp']['list']>([])
const teamLog = ref<ApiMap['/log/team/list']['resp']['list']>([])
const overlayMode = ref<'student' | 'team' | 'ai'>('team') // true - Student, false - Team

const selectedStudentId = ref<number>(0)
const pageSizeStudent = ref<number>(10)
const pageNumStudent = ref<number>(1)
const totalNumStudent = ref<number>(0)
const selectedStudentName = ref<string>('')
const studentHeaders = [
  { title: '编号', value: 'id' },
  { title: '学生 ID', value: 'studentId' },
  { title: '小组 ID', value: 'teamId' },
  { title: '游戏 ID', value: 'gameId' },
  { title: '得分', value: 'score' },
  { title: '原因', value: 'reason' },
  { title: '轮次', value: 'round' },
  { title: '阶段', value: 'phase' },
  { title: '时间', value: 'gmtCreate' },
  { title: '备注', value: 'comment' }
]

const selectedTeamId = ref<number>(0)
const pageSizeTeam = ref<number>(10)
const pageNumTeam = ref<number>(1)
const totalNumTeam = ref<number>(0)
const teamHeaders = [
  { title: '编号', value: 'id' },
  { title: '小组 ID', value: 'teamId' },
  { title: '游戏 ID', value: 'gameId' },
  { title: '得分', value: 'score' },
  { title: '原因', value: 'reason' },
  { title: '轮次', value: 'round' },
  { title: '阶段', value: 'phase' },
  { title: '时间', value: 'gmtCreate' },
  { title: '备注', value: 'comment' }
]

function handleShowAI() {
  overlayMode.value = 'ai'
  showOverlay.value = true
}

function handleShowTeamLog(data: { item: { teamId: number }, index: number }) {
  const { item } = data
  overlayMode.value = 'team'
  showOverlay.value = true
  selectedTeamId.value = item.teamId
  useTeamLog()
}

function handleShowStudentLog(data: { mode: string, item: { studentId: number, studentName: string }, index: number }) {
  const { mode, item } = data
  if (mode === 'team') return
  overlayMode.value = 'student'
  showOverlay.value = true
  selectedStudentId.value = item.studentId
  selectedStudentName.value = item.studentName
  useStudentLog()
}

const useStudentLog = () => {
  useApi({
    api: log.StudentLog({
      gameId: GameStatus.value!.id,
      studentId: selectedStudentId.value,
      pageNum: pageNumStudent.value,
      pageSize: pageSizeStudent.value,
    }),
    onSuccess: resp => {
      studentLog.value = (resp.data as ApiMap['/log/student/list']['resp']).list
      totalNumTeam.value = (resp.data as ApiMap['/log/student/list']['resp']).total
    }
  })
}

const useTeamLog = () => {
  useApi({
    api: log.TeamLog({
      gameId: GameStatus.value!.id,
      teamId: selectedTeamId.value,
      pageNum: pageNumTeam.value,
      pageSize: pageSizeTeam.value,
    }),
    onSuccess: resp => {
      teamLog.value = (resp.data as ApiMap['/log/team/list']['resp']).list
      totalNumStudent.value = (resp.data as ApiMap['/log/team/list']['resp']).total
    }
  })
}

watch(() => props.data, newVal => {
  GameStatus.value = newVal ?? null
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-h5 text-indigo-lighten-2" }, "总结页面", -1)),
        _createVNode(_component_v_btn, {
          variant: "outlined",
          color: "primary",
          onClick: handleShowAI
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("AI总结")
          ])),
          _: 1,
          __: [5]
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(RankList, {
              "enable-edit": false,
              "max-height": "630",
              class: "mr-6",
              style: {"flex":"1"},
              data: GameStatus.value,
              onClick: handleShowTeamLog
            }, null, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(TileRank, {
              "enable-edit": false,
              "max-height": "630",
              style: {"flex":"1"},
              data: GameStatus.value,
              mode: "student",
              onClick: handleShowStudentLog
            }, null, 8, ["data"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_v_overlay, {
      modelValue: showOverlay.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showOverlay).value = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        (overlayMode.value !== 'ai')
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                (overlayMode.value === 'student')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(selectedStudentName.value) + " - 得分日志记录", 1))
                  : _createCommentVNode("", true),
                (overlayMode.value === 'team')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "第 " + _toDisplayString(selectedTeamId.value) + " 组 - 得分日志记录", 1))
                  : _createCommentVNode("", true),
                (overlayMode.value === 'student')
                  ? (_openBlock(), _createBlock(_component_v_data_table_server, {
                      key: 2,
                      "items-per-page": pageSizeStudent.value,
                      "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((pageSizeStudent).value = $event)),
                      page: pageNumStudent.value,
                      "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((pageNumStudent).value = $event)),
                      "items-length": totalNumStudent.value,
                      "no-data-text": "未查询到日志信息",
                      density: "comfortable",
                      headers: studentHeaders,
                      "items-per-page-text": "每页展示：",
                      "page-text": `第 ${pageNumStudent.value} 页，共 ${totalNumStudent.value} 项`,
                      "onUpdate:options": useStudentLog,
                      class: "pa-4",
                      items: studentLog.value
                    }, null, 8, ["items-per-page", "page", "items-length", "page-text", "items"]))
                  : _createCommentVNode("", true),
                (overlayMode.value === 'team')
                  ? (_openBlock(), _createBlock(_component_v_data_table_server, {
                      key: 3,
                      "items-per-page": pageSizeTeam.value,
                      "onUpdate:itemsPerPage": _cache[2] || (_cache[2] = ($event: any) => ((pageSizeTeam).value = $event)),
                      page: pageNumTeam.value,
                      "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((pageNumTeam).value = $event)),
                      "items-length": totalNumTeam.value,
                      "no-data-text": "未查询到日志信息",
                      density: "comfortable",
                      headers: teamHeaders,
                      "items-per-page-text": "每页展示：",
                      "page-text": `第 ${pageNumTeam.value} 页，共 ${totalNumTeam.value} 项`,
                      "onUpdate:options": useTeamLog,
                      class: "pa-4",
                      items: teamLog.value
                    }, null, 8, ["items-per-page", "page", "items-length", "page-text", "items"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(ChatBox, {
              key: 1,
              id: GameStatus.value.id
            }, null, 8, ["id"]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})